import S from 's-js'

import { PCUser } from 'data/models/PCUser';
import { DomainSettings } from 'data/models/DomainSettings';

/**
 * NOTE: the localStorage key names are also embedded into the index.tmpl.html file, so if you change them here, be sure to change index.tmpl.html as well
 */
const CSSFILE_LOCALSTORAGE_KEY = "UIThemeCssFile",
    CSSCLASSES_LOCALSTORAGE_KEY = "UIThemeCssClasses",
    CSSFILE_DEFAULT = "dist/Content/Site.css",
    CSSCLASSES_DEFAULT = "";

export type UIThemeSetter = ReturnType<typeof UIThemeSetter>;
export const UIThemeSetter = (
    initialDataLoaded : () => boolean,
    user : () => PCUser | null, 
    domainSettings : DomainSettings
) => {
    const 
        userTheme = () => user() && user()!.EffectiveUITheme(),
        anonTheme = () => domainSettings.DefaultUITheme(),
        // before initial load, precedence is cached theme > anonymous theme defined in environment.config.js > default
        // after initial load, it's user theme > anonymous theme > default
        CssFile = () => 
            !initialDataLoaded() && CSSFILE_LOCALSTORAGE_KEY in localStorage ? localStorage[CSSFILE_LOCALSTORAGE_KEY] :
            userTheme() ? userTheme()!.CssFile() :
            anonTheme() ? anonTheme()!.CssFile() :
            CSSFILE_DEFAULT,
        CssClasses = () => 
            !initialDataLoaded() && CSSCLASSES_LOCALSTORAGE_KEY in localStorage ? localStorage[CSSCLASSES_LOCALSTORAGE_KEY] :
            userTheme() ? userTheme()!.CssClasses() :
            anonTheme() ? anonTheme()!.CssClasses() :
            CSSCLASSES_DEFAULT;

    // as soon as we've got a theme loaded, keep it cached in local storage.  we'll use this right off the bat on the next load, 
    // (see code in index.tmpl.html) before we've even gotten the user's data from the server.  
    // that way we avoid a flash of the wrong theme for returning users.
    S(() => {
        if (initialDataLoaded()) {
            localStorage[CSSFILE_LOCALSTORAGE_KEY] = CssFile();
            localStorage[CSSCLASSES_LOCALSTORAGE_KEY] = CssClasses();
        }
    });

    return { CssFile, CssClasses };
}


// WEBPACK FOOTER //
// ./apps/portcall/uithemesetter/model.ts